import React, { useEffect, useRef, useState } from 'react';
import { Checkbox, Col, Form, message, Row, Tabs } from 'antd';
import ProForm, { ProFormInstance } from '@ant-design/pro-form';
import { FileUploadUtility, WdiFileList } from '@/components/WdiControls/WdiFileUpload';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import { FormPageProps } from '@/components/WdiBus/FormPage';
import { initPageContext, ViewEntityProps } from '../../SalesContract/components/data';
import { ResponseStatus } from '@/utils/request';
import { WdiPanel } from '@/components/WdiControls/WdiPanel';
import { WdiCardTitle, wdiCore, WdiInput } from '@/components/WdiControls';
import SalesContractTermsForApproval from './details';
import { SalesContractTerms } from '@/services/contract/salescontractterms';
import DataStore from '@/components/GridWidget/DataStore';
import { WdiButtonContainer } from '@/components/WdiBus/Buttons';
import { SalesContractMoreWapper } from '../../SalesContract/components/Button';
import SalesContractHistoryForPanel from './history';
import { SalesContractHistory } from '@/services/contract/salescontracthistory';
import { Enum } from '@/enums/system';
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const SalesContractApproval: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>();
  const [salesContractHistorys, setSalesContractHistorys] = useState<any[]>();
  const [entity, setEntity] = useState<ViewEntityProps>();

  const [contractType, setContractType] = useState<number>();
  const [pageTypeId, setPageTypeId] = useState<number>();

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity = result.data;
        setContractType(viewEntity.contractType);
        setPageTypeId(viewEntity.pageTypeId);
        const { salesContract, soldTo, soldToGroup, bohq, region, modifiedUser } = viewEntity;
        if (salesContract) {
          formRef.current?.setFieldsValue({
            contractCode: salesContract.contractCode,
            contractName: salesContract.contractName,
            contractDate: wdiCore.Date.Join(
              salesContract.beginDate,
              salesContract.endDate,
              'yyyyMM',
            ),
            owner: salesContract.owner,
            signDate: wdiCore.Date.ToString(salesContract.signDate, 'yyyy-MM-dd'),
            customerSignatory: salesContract.customerSignatory,
            modifiedDate: salesContract.modifiedDate,
            contractVersion: salesContract.contractVersion,
            remark: salesContract.remark,
            isAutoAppend: salesContract.isAutoAppend,
            boNames: salesContract.boNames,
            fileInfo: FileUploadUtility.parse(salesContract.fileName, salesContract.filePath),
          });
          SalesContractTerms.getSalesContractTerms(salesContract.salesContractId).then(
            (response) => {
              setDataSource(DataStore.init(response.data));
            },
          );
          SalesContractHistory.query(salesContract.salesContractId).then((response) => {
            setSalesContractHistorys(DataStore.init(response.data));
          });
        }
        if (soldTo) {
          formRef.current?.setFieldsValue({
            soldToCode: wdiCore.String.CodeOrName(soldTo.soldToCode, soldTo.soldToName),
          });
        }
        if (soldToGroup) {
          formRef.current?.setFieldsValue({
            soldToGroupId: wdiCore.String.CodeOrName(
              soldToGroup.soldToGroupCode,
              soldToGroup.soldToGroupName,
            ),
          });
        }
        if (bohq) {
          formRef.current?.setFieldsValue({
            bohqId: bohq.bohqName,
          });
        }
        if (region) {
          formRef.current?.setFieldsValue({
            regionId: region.name,
          });
        }
        if (modifiedUser) {
          formRef.current?.setFieldsValue({
            modifiedUserId: modifiedUser.name,
          });
        }
        setEntity(viewEntity);
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = '';
      if (pageTypeId != null && pageTypeId == Enum.PageType.CONTRACT_APPLICATION) {
        title = '一级客户合同信息';
      } else {
        title = '二级客户合同信息';
      }
      if (entity?.salesContract?.contractStatusId == Enum.SalesContractStatus.INVALID) {
        title += '，已无效';
      } else if (entity?.salesContract?.contractStatusId == Enum.SalesContractStatus.EFFECTIVE) {
        title += '，有效';
      }

      if (props.setPageTitle)
        props.setPageTitle(
          <div>
            <span>{title}</span>
            <WdiButtonContainer>
              <SalesContractMoreWapper
                onClose={props.onClose}
                callback={props.callback}
                salesContractId={Number(entity?.salesContract?.salesContractId)}
                pageTypeId={Number(entity?.pageTypeId)}
                contractStatusId={Number(entity?.salesContract?.contractStatusId)}
              />
            </WdiButtonContainer>
          </div>,
        );
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <Tabs defaultActiveKey="1" size="large">
        <TabPane tab={<span>资料</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => {
                return <></>;
              },
            }}
          >
            <WdiPanel
              collapsed={true}
              title={<WdiCardTitle iconType={Enum.IconType.CONTRACT} title="合同信息" />}
            >
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="soldToCode" label="客户">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="soldToGroupId" label="返利客户组">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="bohqId" label="预算归属">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="boNames" label="使用部门范围(不填即全国)">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="contractCode" label="合同编号">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="contractName" label="合同名称">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="contractDate" label="合同期间">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="owner" label="合同负责人">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="signDate" label="签约日期">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="customerSignatory" label="客户方签约人">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="isAutoAppend" label="是否自动追溯" valuePropName="checked">
                    <Checkbox disabled={true} />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="modifiedUserId" label="合同修改人">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="modifiedDate" label="合同修改时间">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}>
                  <Form.Item name="remark" label="备注">
                    <WdiEditor readOnly={true} />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="附件"
                    valuePropName="fileList"
                    getValueFromEvent={(e: any) => {
                      return e.fileList || [];
                    }}
                  >
                    <WdiFileList />
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
          </ProForm>
          {dataSource && (
            <SalesContractTermsForApproval
              dataSource={dataSource}
              data={{ contractType: contractType }}
            />
          )}
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="2">
          {salesContractHistorys && (
            <SalesContractHistoryForPanel dataSource={salesContractHistorys} />
          )}
        </TabPane>
      </Tabs>
    </>
  );
};
export default SalesContractApproval;
